import { useMutation } from '@tanstack/react-query';
import { createBehaviorRequest } from '../requests/createBehaviorRequest';
import { useNavigate } from 'react-router-dom';
import { BehaviorFormProps } from '../types/behavior.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useCreateBehavior() {
	const navigate = useNavigate();

	const createBehavior = useMutation({
		mutationFn: async (data: BehaviorFormProps) => {
			return createBehaviorRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully created!', type: 'success' });
			queryClient.invalidateQueries(['BEHAVIOR_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { createBehavior };
}
